import { updatableListActions } from '../../GeneralListFunctions/actionFactory'
export default updatableListActions('ORGANIZATION_GROUP_ORGANIZATION')
